import { StreamDeckPage } from './StreamDeckPage';

export default StreamDeckPage;
